<template>
  <div>
    <iframe
      src="https://www.youtube.com/embed/TtMzTGfs-fc?t=34"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
    <div class="popup bsod container">
      <h1 class="neg title"><span class="bg">TUTORIAL</span></h1>
      <h2>How to pay respects:</h2>
      <p>
        * Listen to the whole
        <a href="https://kizi404.bandcamp.com/releases" target="_blank"
          >record</a
        ><br />
        * Be amazed by those geniuses (see above) <br />
        * Enter the passworld <br />
        * Press enter<br />
        * If it doesn't work, may'be try buying the record, then repeat
      </p>
      <nav class="nav">
        <a class="link" @click="goBack()">TRY AGAIN</a>
      </nav>
    </div>
  </div>
</template>

<script>
import MainMixinVue from "./utilities/MainMixin.vue";
export default {
  Name: "TutoRespect",
  title: "Press F",
  mixins: [MainMixinVue],
  methods: {
    goBack() {
      if (this.isMobile) {
        this.$router.push("/passworld-mobile");
      } else {
        this.$router.push("/passworld");
      }
    },
  },
  created() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/landing-error.scss";
iframe {
  margin-left: -10px;
  height: 100vh;
  width: 101vw;
}

body,
html {
  overflow: scroll;
}

.bsod {
  padding-top: 2%;
  padding-bottom: 2%;
}

@media only screen and (max-width: 1300px) {
  iframe {
    height: 75vh;
  }
  h1 {
    font-size: 3rem;
  }

  h2,
  p {
    font-size: 1.5rem;
    text-align: center;
    font-family: $font-stack;
  }
}

@media only screen and (min-width: 1000px) {
  iframe {
    height: 90vh;
  }
}
</style>
